<template>
  <div class="p-1">
    <!-- Totals banner (montant total des demandes filtrées) -->
    <div v-if="paginate.total" class="mx-2 mb-2 flex flex-wrap items-center gap-3 bg-white rounded-lg shadow px-4 py-3">
      <div class="flex items-center gap-2">
        <i class="material-icons text-green-600">event_note</i>
        <span class="text-sm text-gray-500">{{ paginate.total }} demande(s)</span>
      </div>
      <div class="ml-auto flex items-center gap-4">
        <div v-if="totals && totals.amountMAD" class="text-right">
          <div class="text-xs text-gray-400 uppercase">Total MAD</div>
          <div class="font-bold text-gray-700">{{ Math.floor(totals.amountMAD) }} <sup>MAD</sup></div>
        </div>
        <div v-if="totals && totals.amount" class="text-right">
          <div class="text-xs text-gray-400 uppercase">Total USD</div>
          <div class="font-bold text-gray-700">{{ parseFloat(totals.amount).toFixed(2) }} <sup>USD</sup></div>
        </div>
      </div>
    </div>

    <!-- Tabs status — switch rapide bين les demandes -->
    <div class="mx-2 mb-2 flex flex-wrap gap-2">
      <button v-for="tab in statusTabs" :key="tab.value" @click="switchStatus(tab.value)"
        class="px-4 py-2 rounded-full border text-sm font-semibold transition-colors focus:outline-none"
        :class="activeStatus === tab.value ? tab.activeClass : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'">
        {{ tab.label }}
      </button>
    </div>

    <div-table
      :config="configList"
      :data="balances"
      :element="element"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @searchSellers="searchSellers"
      @search="search"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      @Changelimit="Changelimit"
      @selectAllCheckbox="selectAllCheckbox"
      @getRowDetail="getRowDetail"
      :tabId="tabId"
    ></div-table>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      configList: config.list,
      loading: false,
      balances: [],
      totals: {},
      element: {},
      sellers: [],
      tabId: [],
      show_modal: false,
      filters: {},
      limit: 100,
      activeStatus: '',
      statusTabs: [
        { value: '', label: 'Tous', activeClass: 'bg-gray-700 text-white border-gray-700' },
        { value: 'pending', label: 'En attente', activeClass: 'bg-yellow-500 text-white border-yellow-500' },
        { value: 'paid', label: 'Payé', activeClass: 'bg-green-600 text-white border-green-600' },
        { value: 'rejected', label: 'Rejeté', activeClass: 'bg-red-600 text-white border-red-600' },
      ],
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
    };
  },
  async mounted() {
    // Page CEO — interdite l'Seller/Partner (7tى b'URL directe) => redirect l'profil
    if (this.currentUser && ['Seller', 'Partner'].includes(this.currentUser.type)) {
      this.$router.replace('/profil');
      return;
    }
    if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
    else this.$f.objectToQueryString({ limit: this.limit, country: this.idWharhouse.country });

    this.activeStatus = this.filters.status || '';   // sync tab active mn URL

    if (this.filters.name) await this.search(this.filters.name);
    else await this.getBalances(this.filters);

    if (this.currentUser.type != "Seller") {
      await this.getSellers();
      this.setDataSelect("seller", this.sellers, null);
    }

    if (this.currentUser.type == "Seller") {
      let pos = this.configList.columns.map(function (e) { return e.name; }).indexOf('seller');
      if (pos != -1) this.configList.columns.splice(pos, 1);
    }
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({ user: _.pick(this.currentUser, ['countries']) });
    },
  },
  watch: {
    'warhouseSelected': async function (oldVal, newVal) {

    },
    'idWharhouse': async function (oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.reset();
      if (this.currentUser.type != "Seller") {
        await this.getSellers();
        this.setDataSelect("seller", this.sellers, null);
      }
    }
  },
  methods: {
    selectAllCheckbox($event) {
      let columns = document.querySelectorAll('.rowCheckbox');
      this.tabId = [];
      if ($event.target.checked == true) {
        columns.forEach(column => {
          column.checked = true;
          this.tabId.push(column.id);
        });
      } else {
        columns.forEach(column => { column.checked = false });
        this.tabId = [];
      }
    },
    getRowDetail(item, id) {
      let itemInRow = this.tabId.filter(item => item === id);
      let isItemInRow = itemInRow.length > 0;

      if (isItemInRow) {
        let pos = this.tabId.map(function (e) { return e; }).indexOf(id);
        this.tabId.splice(pos, 1);
      } else {
        this.tabId.push(id);
      }
      if (this.tabId.length === 0) {
        let columns = document.querySelectorAll('.checkallbbox');
        columns.forEach(column => { column.checked = false });
      }
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      const filter = {
        type: JSON.stringify(["Seller", "Partner"]),
        countries: this.idWharhouse.country,
        limit: this.limit
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) this.sellers = res.content.results.map(s => ({ ...s, fullName: s.fullName + ' (' + s.type + ')' }));
      else this.sellers = [];
    },
    searchSellers: _.debounce(async function (search, event) {
      const filter = {
        type: JSON.stringify(["Seller", "Partner"]),
        limit: this.limit,
        countries: this.idWharhouse.country,
        name: search,
      };
      const res = await this.$server.find("users", filter);

      if (res.content.results) this.sellers = res.content.results.map(s => ({ ...s, fullName: s.fullName + ' (' + s.type + ')' }));
      else this.sellers = [];
      this.setDataSelect("seller", this.sellers, null);
    }, 500),
    async reset(data) {
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      if (this.filters['limit']) lmitt = this.filters['limit'];
      this.filters['page'] = 1;
      this.$f.objectToQueryString({ limit: lmitt, country: this.idWharhouse.country });
      await this.getBalances({ limit: lmitt });
    },
    // Switch rapide bين les statuts (tabs)
    async switchStatus(status) {
      this.activeStatus = status;
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      delete this.filters.page;
      delete this.filters.name;
      this.paginate.currentpage = 1;
      if (!this.filters['limit']) this.filters['limit'] = this.limit;
      if (status) this.filters.status = status; else delete this.filters.status;
      this.$f.objectToQueryString(this.filters);
      await this.getBalances(this.filters);
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      delete this.filters.page;
      delete this.filters.name;
      this.paginate.currentpage = 1;
      this.activeStatus = data.status || '';   // sync tab m3a filter dropdown
      if (!this.filters['limit']) this.filters['limit'] = this.limit;
      if (data.status) this.filters.status = data.status; else delete this.filters.status;
      if (data.defaultCurrency) this.filters.defaultCurrency = data.defaultCurrency; else delete this.filters.defaultCurrency;
      if (data.date) this.filters.date = data.date; else delete this.filters.date;
      if (data.seller) this.filters.seller = data.seller._id || data.seller; else delete this.filters.seller;
      this.$f.objectToQueryString(this.filters);
      await this.getBalances(this.filters);
    },
    async refresh() {
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else await this.getBalances(this.filters);
      if (this.filters['page'] && this.filters['page'] > 1 && this.balances.length == 0) {
        this.filters['page'] = --this.filters['page'];
        this.$f.objectToQueryString(this.filters);
        await this.getBalances(this.filters);
      }
    },
    showOrders(index) {
      if (this.element !== this.balances[index]) {
        this.element = this.balances[index];
      } else this.element = null;
    },
    async getBalances(filters) {
      this.loading = true;
      if (this.currentUser.type === "Seller") filters.seller = this.currentUser._id;
      const res = await this.$server.search("balancesHistories", {
        ...filters,
        payment: false,
        getTotalsByCurrency: true,
      });
      this.loading = false;
      if (res.content.results) {
        // Montant kaytبان 3la 7sab defaultCurrency (stored, kaytkrea mn payment method) — MAD default
        this.balances = res.content.results.map(r => {
          const cur = r.defaultCurrency === 'USD' ? 'USD' : 'MAD';
          const val = cur === 'USD' ? (r.amount || 0) : (r.amountMAD || 0);
          const shown = cur === 'USD' ? parseFloat(val).toFixed(2) : Math.floor(val);
          // Fين CEO khass yصيفط l-flous — payment method dyal seller
          const pm = r.seller && r.seller.paymentMethod;
          let displayPaymentMethod = '-';
          if (pm && pm.type === 'bank') displayPaymentMethod = `🏦 ${pm.bankName || 'Bank'} — ${pm.rib || (r.seller && r.seller.rib) || ''}`.trim();
          else if (pm && ['payoneer', 'wise'].includes(pm.type)) displayPaymentMethod = `${pm.type === 'payoneer' ? '💳 Payoneer' : '💳 Wise'} — ${pm.email || ''}`.trim();
          else if (r.seller && r.seller.rib) displayPaymentMethod = `🏦 RIB — ${r.seller.rib}`;
          return { ...r, displayCurrency: cur, displayAmount: `${shown} ${cur}`, displayPaymentMethod };
        });
        this.totals = res.content.totals || {};
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.balances = [];
        this.totals = {};
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;
      if (this.filters['limit']) limitt = this.filters['limit'];

      let search = { name: data.trim(), limit: parseInt(limitt), payment: false, getTotalsByCurrency: true };
      if (this.currentUser.type == "Seller") search.seller = this.currentUser._id;
      this.$f.objectToQueryString(search);
      const res = await this.$server.find("balancesHistories", search);
      if (res.content.results) {
        this.balances = res.content.results;
        this.totals = res.content.totals || {};
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.balances = [];
        this.totals = {};
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      this.filters['page'] = page;
      this.$f.objectToQueryString(this.filters);
      this.getBalances(this.filters);
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject()) this.filters = this.$f.QueryStringToobject();
      this.filters['limit'] = val;
      this.filters['page'] = 1;
      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else this.getBalances(this.filters);
    },
  },
};
</script>

<style>
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (min-width: 640px) {
  thead tr:not(:first-child) {
    display: none;
  }
}

td:not(:last-child) {
  border-bottom: 0;
}

th:not(:last-child) {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
</style>
